<template>
  <div>
    <div v-if="!isLoggedIn" class="HEADER"></div>
    <app-header-base v-bind="headerOptions">
      <app-header-custom v-bind="headerOptions">
        <client-only>
          <app-header-tos v-if="isTos" v-bind="headerOptions"/>
          <template v-else-if="isLoggedIn">
            <div >
              <new-app-header-pro v-if="isPro" v-bind="headerOptions"/>
              <app-header-consumer v-else v-bind="headerOptions"/>
            </div>
          </template>
          <app-header-public v-else v-bind="headerOptions"/>
        </client-only>
      </app-header-custom>
    </app-header-base>
    <div v-if="!isPro" class="SPACER"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppHeaderBase from '@/layouts/components/AppHeaderBase';
import NewAppHeaderPro from '@/layouts/components/newAppHeaderPro/';
import AppHeaderConsumer from '@/layouts/components/AppHeaderConsumer';
import AppHeaderTos from '@/layouts/components/AppHeaderTos';
import AppHeaderPublic from '@/layouts/components/AppHeaderPublic';
import AppHeaderCustom from '@/layouts/components/AppHeaderCustom';

export default {
  name: 'app-header',
  components: {
    AppHeaderBase,
    NewAppHeaderPro,
    AppHeaderConsumer,
    AppHeaderPublic,
    AppHeaderCustom,
    AppHeaderTos,
  },
  props: {
    headerOptions: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters('user', [
      'isPro',
      'isLoggedIn',
    ]),
    isTos () {
      return this.headerOptions && this.headerOptions.tos;
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .HEADER {
    position: fixed;
    width:100vw;
  }
  .SPACER {
    height:82px;
  }
</style>
